export { BotDetectCaptchaModule } from './src/botdetect-captcha.module';
export { CaptchaComponent } from './src/captcha.component';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/angular-captcha/index.js
// module id = ./src/app/angular-captcha/index.js
// module chunks = main